import { loadStripe } from '@stripe/stripe-js'

export default {
  data () {
    return {
      errorMessage: null,
      success: false,
      captured: false
    }
  },

  methods: {
    async setupStripe (regionShortcode) {
      this.stripe = await loadStripe(this.$stripePublicKey(regionShortcode))
    },
    populateFields () {
      if (this.stripe) {
        const elements = this.stripe.elements()

        this.cardNumber = elements.create('cardNumber', {
          showIcon: true
        })
        this.cardNumber.mount('#card-element')

        this.cardExpiry = elements.create('cardExpiry')
        this.cardExpiry.mount('#exp-element')

        this.cardCvc = elements.create('cardCvc')
        this.cardCvc.mount('#cvc-element')
      }
    },
    paymentIntent (paymentIds, complete, fail) {
      this.errorMessage = null
      return this.$http
        .post('/card/payment-intent/', {
          paymentIds: paymentIds
        })
        .then(response => {
          this.intentToken = response.data.intent_id
          this.clientSecret = response.data.client_secret
          return this.confirmPayment(complete, fail)
        })
    },
    confirmPayment (complete, fail) {
      return this.stripe
        .confirmCardPayment(this.clientSecret, {
          payment_method: {
            card: this.cardNumber
          }
        })
        .then(result => {
          if (result.error) {
            this.errorMessage = result.error.message
          } else if (result.paymentIntent.status === 'succeeded') {
            this.success = true
            complete(result)
          } else if (
            result.paymentIntent.status === 'requires_capture'
          ) {
            this.captured = true
          }
        })
    },
    createCheckoutSession (paymentIds) {
      return this.$axios.post('/api/card/create-checkout-session', {
        paymentIds
      })
    }
  }
}
